<template>
  <v-app>
    <v-main class="pb-0">
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  methods: {
    createMetaTitle: function () {
      document.title = this.$route.meta.title;
    },
  },
  mounted: function () {
    this.createMetaTitle();
  },
};
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
